export default {
  ADD_WORK: 'ADD_WORK',
  READ_WORK: 'READ_WORK',
  EDIT_WORK: 'EDIT_WORK',
  DELETE_WORK: 'DELETE_WORK',
  READ_EDIT: 'READ_EDIT_WORK',

  // 途中增项
  ADD_PARTS_IN_WORK: 'ADD_PARTS_IN_WORKING',
  READ_ADD_PARTS: 'READ_ADD_PARTS',

  // 确认工单
  CONFIRM_WORK: 'CONFIRM_WORK',
  // 改派
  DISPATCH: 'DISPATCH_WORK',
  // 推进
  PUSH: 'PUSH_WORK',
  // 中断
  INTERRUPT: 'INTERRUPT_WORK',
  // 终止
  STOP: 'STOP_WORK',
  // 回退
  BACK: 'FALLBACK_WORK', // FALLBACK_WORK
  // 转机修
  MACHINE_REPAIR: 'MACHINE_REPAIR',
  // 撤回
  WITHDRAW: 'WITHDRAW',
  // 返工
  REWORK: 'REWORK',
  // 质检
  QUALITY: 'QUALITY',

  // 交车
  DELIVERY: 'DELIVERY',
  // 结算
  SETTLEMENT: 'SETTLEMENT',

  // 开工完工
  START_WORK: 'START_WORK',
  END_WORK: 'END_WORK',
  START_END_WORK: 'START_END_WORK',

  // 开始洗车/完成洗车
  START_WASH: 'START_WASH',
  END_WASH: 'END_WASH',
  START_END_WASH: 'START_END_WASH',

  // 品牌
  ADD_BRAND: 'ADD_BRAND',
  EDIT_BRAND: 'EDIT_BRAND',

  // 车系
  ADD_MODEL: 'ADD_MODEL',
  EDIT_MODEL: 'EDIT_MODEL',

  // 客户
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  EDIT_CUSTOMER: 'EDIT_CUSTOMER',

  // 工组
  ADD_TEAM: 'ADD_TEAM',
  EDIT_TEAM: 'EDIT_TEAM',
  DELETE_TEAM: 'DELETE_TEAM',

  // 工位
  ADD_STATION: 'ADD_STATION',
  EDIT_STATION: 'EDIT_STATION',
  DELETE_STATION: 'DELETE_STATION',

  // 工序
  ADD_PROCEDURE: 'ADD_PROCEDURE',
  EDIT_PROCEDURE: 'EDIT_PROCEDURE',
  DELETE_PROCEDURE: 'DELETE_PROCEDURE',

  // 施工项目
  ADD_PARTS: 'ADD_PARTS',
  EDIT_PARTS: 'EDIT_PARTS',

  // 施工项目系数
  ADD_COE: 'ADD_COE',
  EDIT_COE: 'EDIT_COE',
  DELETE_COE: 'DELETE_COE',

  // 用户管理
  ADD_USER: 'ADD_USER',
  EDIT_USER: 'EDIT_USER',
  DELETE_USER: 'DELETE_USER',

  // 机构管理
  ADD_ORGAN: 'ADD_ORGAN',
  EDIT_ORGAN: 'EDIT_ORGAN',
  DELETE_ORGAN: 'DELETE_ORGAN',

  // 仓库
  WAREHOUSE: 'WAREHOUSE',
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  NEILING: 'NEILING',
  NEILING_SHENHE: 'NEILING_SHENHE'
}
